import React, { useState, useEffect } from "react";
import { collection, addDoc, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import { db, auth } from "../../../../firebase/firebase";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import style from "./TeacherSlots.module.css"
import "react-big-calendar/lib/css/react-big-calendar.css";
import { SubmitButton, CancelButton, ExitButton } from "../../../../components/styled/styledbuttons/buttons";
import { FaTrash } from "react-icons/fa";
import {
  TEACHER_CALENDAR_CULTURE,
  teacherCalendarMessages,
  useTeacherCalendarLocale,
} from "../../../../constants/teacherCalendar";

const localizer = momentLocalizer(moment);
const SLOT_DURATION_MS = 30 * 60 * 1000;

/** Always one 30-minute slot from the clicked start (ignores drag end). */
function normalizeToHalfHourSlot(slotInfo) {
  const start =
    slotInfo.start instanceof Date ? slotInfo.start : new Date(slotInfo.start);
  return {
    ...slotInfo,
    start,
    end: new Date(start.getTime() + SLOT_DURATION_MS),
  };
}

const TeacherSlots = () => {
  useTeacherCalendarLocale();
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [module, setModule] = useState(false);

  const teacherID = auth.currentUser.uid; 

  const slotsCollectionRef = collection(db, "slots");

  // Fetch teacher's available slots
  const fetchSlots = async () => {
    try {
      const q = query(slotsCollectionRef, where("teacherID", "==", teacherID));
      const data = await getDocs(q);
      const fetchedSlots = data.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        start: doc.data().start.toDate(),
        end: doc.data().end.toDate(),
      }));
      setSlots(fetchedSlots);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };

  useEffect(() => {
    fetchSlots();
  }, []);

  const addSlot = async () => {
    setModule(false)
    if (!selectedSlot) {
      alert("Please select a slot to add.");
      return;
    }
    try {
      const { start, end } = normalizeToHalfHourSlot(selectedSlot);
      const newSlot = {
        teacherID,
        start,
        end,
        isBooked: false,
      };
      const docRef = await addDoc(slotsCollectionRef, newSlot);
      setSlots([...slots, { ...newSlot, id: docRef.id }]);
      setSelectedSlot(null);
    } catch (error) {
      console.error("Error adding slot:", error);
    }
  };

  const removeSlot = async (slotId) => {
    try {
      await deleteDoc(doc(db, "slots", slotId));
      setSlots(slots.filter((slot) => slot.id !== slotId));
    } catch (error) {
      console.error("Error removing slot:", error);
    }
  };

  const handleSelectSlot = (slotInfo) => {
    if (slotInfo.start < new Date()) {
      alert("Cannot select a past slot.");
      return;
    }
    // Ignore multi-slot drag releases; clicks (and single-cell taps) only.
    if (slotInfo.action === "select") {
      const durationMs =
        new Date(slotInfo.end).getTime() - new Date(slotInfo.start).getTime();
      if (durationMs > SLOT_DURATION_MS) {
        return;
      }
    }
    setModule(true);
    setSelectedSlot(normalizeToHalfHourSlot(slotInfo));
  };

  /** Block drag highlight beyond a single 30-minute cell (keeps touch taps working). */
  const handleSelecting = ({ start, end }) => {
    const durationMs = new Date(end).getTime() - new Date(start).getTime();
    return durationMs <= SLOT_DURATION_MS;
  };
  const exitHandler = () => {
    setModule(false);
  };
    const CustomSlot = ({ event }) => { 
      return ( 
      <div>
        <strong>{event.title}</strong>
          <FaTrash
            className={style.trashBin}
            onClick={() => removeSlot(event.id)}
          />
      </div>
    )};
    const isMobile = window.innerWidth < 768;
  return (
    <>
      {module && (
        <div className={style.module}>
          <SubmitButton onClick={addSlot}>Add This Slot</SubmitButton>
          <CancelButton onClick={exitHandler} >Cancel</CancelButton>
          <ExitButton onClick={exitHandler} >X</ExitButton>
        </div>
      )}
      <div className={style.app}>
      <Calendar
        localizer={localizer}
        messages={teacherCalendarMessages}
        culture={TEACHER_CALENDAR_CULTURE}
        events={slots}
        views={isMobile ? ['agenda', 'day'] : ['week', 'day', 'agenda']}
        defaultView={isMobile ? 'day' : 'week'}
        selectable
        onSelectSlot={handleSelectSlot}
        onSelecting={handleSelecting}
        longPressThreshold={250}
        step={30}
        timeslots={1}
        style={{ height: "100vh" }}
        dayLayoutAlgorithm="no-overlap"
        
        components={{
          event: CustomSlot,
        }}
      />
      </div>
    </>
  );
};

export default TeacherSlots;
